import { getReportCardNote, getReportCardTitle, getResolutionBadgeLabel, getSourceBadgeLabel } from '../utils';
import { CardMain, CardMeta, CardNote, ReportCardButton, ResolutionBadge, SelectorRow, SourceBadge } from './styled';
import type { ReportSelectorCardProps, ReportSelectorProps, ResolutionBadgeVariant, SourceBadgeVariant } from './types';

const ReportSelectorCard = ({ report, selected, onSelect }: ReportSelectorCardProps) => {
  const title = getReportCardTitle(report);
  const note = getReportCardNote(report);
  const sourceLabel = getSourceBadgeLabel(report.source);
  const sourceVariant = (report.source ?? 'bgc_screening') as SourceBadgeVariant;
  const resolutionLabel = getResolutionBadgeLabel(report.resolution);
  const resolutionVariant = report.resolution as ResolutionBadgeVariant | null;
  const showMeta = Boolean(note || resolutionLabel);

  return (
    <ReportCardButton type="button" selected={selected} aria-pressed={selected} onClick={() => onSelect(report.id)}>
      <CardMain>
        {title}
        {sourceLabel ? <SourceBadge variant={sourceVariant}>{sourceLabel}</SourceBadge> : null}
      </CardMain>
      {showMeta ? (
        <CardMeta>
          {note ? <CardNote>{note}</CardNote> : <span />}
          {resolutionLabel && resolutionVariant ? (
            <ResolutionBadge variant={resolutionVariant}>{resolutionLabel}</ResolutionBadge>
          ) : null}
        </CardMeta>
      ) : null}
    </ReportCardButton>
  );
};

const ReportSelector = ({ reports, selectedReportId, onSelect }: ReportSelectorProps) => {
  if (reports.length === 0) return null;

  return (
    <SelectorRow role="listbox" aria-label="Drug test reports">
      {reports.map((report) => (
        <ReportSelectorCard
          key={report.id}
          report={report}
          selected={report.id === selectedReportId}
          onSelect={onSelect}
        />
      ))}
    </SelectorRow>
  );
};

export default ReportSelector;
